export type ValidationName = 'required' | 'email' | 'length128';

export type ValidationRule = (val: string) => Validation;

export type Validation = {
  isValid: boolean;
  helperText: string;
};

const emailRegExp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const required = (value: string): Validation => {
  return {
    isValid: !!(value && value.trim().length > 0),
    helperText: 'The field is required',
  };
};

export const email = (value: string): Validation => ({
  isValid: emailRegExp.test(value),
  helperText: 'Invalid email address',
});

export const length128 = (value: string): Validation => ({
  isValid: !!(value && value.trim().length <= 128),
  helperText: 'Value should not exceed 128 characters',
});

export const validationHandler = (
  config: ValidationName[],
  rules: ValidationRule[] = []
): { validateInput: (value: string) => Validation } => {
  const allRules = {
    required,
    email,
    length128,
  };

  const validationRules: ValidationRule[] = [
    ...config.map((rule) => allRules[rule]),
    ...rules,
  ];

  const validateInput = (value: string): Validation => {
    let isValid = true;
    let helperText = '';

    for (let i = 0; i < validationRules.length; i++) {
      const resp = validationRules[i](value);
      if (!resp.isValid) {
        ({ isValid, helperText } = resp);
        break;
      }
    }
    return { isValid, helperText };
  };

  return {
    validateInput,
  };
};
